<template>
	<div class="app-content" :class="appContentClass">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		isEmptyHeader: {
			type: Boolean,
			default: false,
		},
		isEmptyFooter: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		appContentClass() {
			return {
				'app-content--empty-header': this.isEmptyHeader,
				'app-content--empty-footer': this.isEmptyFooter,
			};
		},
	},
};
</script>

<style scoped>
.app-content {
	padding: calc(constant(safe-area-inset-top) + 3.25rem) 0
		calc(constant(safe-area-inset-bottom) + 3.75rem); /* iOS 11.0 버전 */
	padding: calc(env(safe-area-inset-top) + 3.25rem) 0
		calc(env(safe-area-inset-bottom) + 3.75rem); /* iOS 11.2 이상 */
}

.app-content--empty-header {
	padding-top: constant(safe-area-inset-top); /* iOS 11.0 버전 */
	padding-top: env(safe-area-inset-top); /* iOS 11.2 이상 */
}

.app-content--empty-footer {
	padding-bottom: constant(safe-area-inset-bottom); /* iOS 11.0 버전 */
	padding-bottom: env(safe-area-inset-bottom); /* iOS 11.2 이상 */
}
</style>
